// libraries
import { init } from '@makemydeal/dr-activities-customer-vehicles';

// selectors
import { additionalSelectors } from './additionalSelectors';

import { hostActions } from './hostActions';
// constants
import { APP_NAME } from './constants';

const { middlewareMgr } = init(APP_NAME, additionalSelectors, hostActions);

export const customerVehiclesMiddleware = middlewareMgr;

export { APP_NAME };
